import {SlotModuleV2} from '@gongxigames/framework/slotV2/baseClasses/slotModuleV2/SlotModuleV2';
import {GameOnlyEventMap} from '@gongxigames/framework/slotV2/globals';
import {LAYERS} from '@gongxigames/framework/slot';
import {WaitingViewV2} from '@gongxigames/framework/slotV2/modules/waiting/WaitingViewV2';

export class WaitingModuleV2<T extends GameOnlyEventMap> extends SlotModuleV2<T> {
    public static readonly NAME: symbol = Symbol('WaitingModule');
    public static layer = LAYERS.POPUPS;

    protected view!: WaitingViewV2;

    protected onSetupEvents(): void {
        this.emitter.on('CORE.waiting.show', this.view.showPopup.bind(this.view));
        this.emitter.on('CORE.waiting.hide', this.view.hidePopup.bind(this.view));
        this.emitter.on('General.ResourcesLoading.LOADED_ALL_RESOURCES', this.view.hidePopup.bind(this.view));
    }

    protected onInit() {
        this.setView();
    }

    protected setView(): void {
        this.view = new WaitingViewV2({
            updateManager: this.store.updateManager.value!
        });
        this.container.addChild(this.view.container);
    }
}
